var map = {
	"./aparthotelclub/ic_tag_accomodation.png": 77528,
	"./beachful/ic_tag_accomodation.png": 21809,
	"./castlepedia/ic_tag_accomodation.png": 44914,
	"./cocktayl/ic_tag_accomodation.png": 29411,
	"./ic_tag_accomodation.png": 73093,
	"./luxresortclub/ic_tag_accomodation.png": 11387,
	"./parkful/ic_tag_accomodation.png": 20217,
	"./prefabworld/ic_tag_accomodation.png": 73504,
	"./rooftopclub/ic_tag_accomodation.png": 94592,
	"./spaclub/ic_tag_accomodation.png": 49898,
	"./worldcasino/ic_tag_accomodation.png": 44760,
	"./zoopedia/ic_tag_accomodation.png": 89893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28757;